import React from 'react';

const HtmlContent = ({ content }) => {
  if (!content) return null;
  const isReactElement = React.isValidElement(content);
  if(isReactElement) return content;
  return (
    <div dangerouslySetInnerHTML={{ __html: content }} />
  );
};

// const HtmlContent = ({ content }) => {
//   if (!content) return null;
//   if (React.isValidElement(content)) return content;
//   if (typeof content === "string") {
//     return <div dangerouslySetInnerHTML={{ __html: content }} />;
//   }
//   return <div>{content}</div>;
// };

// const HtmlContent = ({ content }) => {
//   if (!content) return null;
//   const isReactElement = React.isValidElement(content);
//   if (isReactElement) return content; // Return React element directly if passed
//   return (
//     <div dangerouslySetInnerHTML={{ __html: content }} />
//   );
// };

export default HtmlContent;